import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { GameMutationKeys } from '../../../keys'
import { UpdateGameRequest, UpdateGameResponse } from '../../../type'
import { updateGame } from '../../services'

interface UpdateGameParams {
	id: string
	payload: UpdateGameRequest
}

export default function useMutationUpdateGame(
	props?: UseBaseMutationOptions<UpdateGameResponse, UpdateGameParams>,
) {
	return useMutation({
		mutationKey: [GameMutationKeys.UpdateGame],
		mutationFn: (params) => updateGame(params.payload, params.id),
		...props,
	})
}
